import React, { Fragment, ReactNode } from "react";
import { FormattedMessage } from "react-intl";

import { uuid } from "@sportal/lib";
import { Delayed } from "../../../../components";

interface Props {
  status: React.ReactNode;
  validationError: React.ReactNode;
}

export const ImageUploadStatus = (props: Props) => {
  const { status, validationError } = props;
  if (!status && !validationError) return null;

  if (!validationError) {
    return <DelayedStatus>{status}</DelayedStatus>;
  }

  return (
    <Fragment>
      <DelayedStatus>
        <FormattedMessage id="aria_image_not_uploaded" />
        {validationError}
      </DelayedStatus>
      <div className="image-upload__error" data-testid="image-upload-error">
        {validationError}
      </div>
    </Fragment>
  );
};

const DelayedStatus = ({ children }: { children: ReactNode }) => {
  return (
    <Delayed key={uuid()}>
      <span className="sr-only" role="alert">
        {children}
      </span>
    </Delayed>
  );
};
